import { ReactNode } from 'react';
import { Box, Tooltip, Typography } from '@material-ui/core';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import * as Styles from './Orders.css';

interface PageHeaderProps {
  title: ReactNode;
  // Help text moves into a tooltip so the page content starts higher.
  description?: string;
  status?: ReactNode;
  actions?: ReactNode;
}

const PageHeader = ({
  title,
  description,
  status,
  actions,
}: PageHeaderProps) => (
  <Styles.Toolbar>
    <Box display="flex" alignItems="center" gridGap={12} flexWrap="wrap">
      <Typography variant="h4" component="h1">
        {title}
      </Typography>
      {status}
      {description && (
        <Tooltip title={description}>
          <InfoOutlinedIcon
            color="action"
            aria-label={description}
            aria-hidden={false}
            role="img"
          />
        </Tooltip>
      )}
    </Box>
    {actions && (
      <Box display="flex" alignItems="center" gridGap={8} flexWrap="wrap">
        {actions}
      </Box>
    )}
  </Styles.Toolbar>
);

export default PageHeader;
